import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { supervisorApi } from '../../api/supervisor.js';
import { adminApi } from '../../api/admin.js';
import UserPill from '../../components/UserPill.jsx';

export default function UserSupervisorConfig() {
  const { id } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);

  function refresh() { supervisorApi.getUserConfig(id).then(setData); }
  useEffect(refresh, [id]);
  useEffect(() => {
    adminApi.users({ limit: 200 }).then((d) => setUsers(d?.items || []));
    supervisorApi.listTags().then((d) => setAllTags(d?.items || []));
  }, []);

  if (!data) return <div className="muted">Loading…</div>;

  async function setSupervisor(supervisorId, secondarySupervisorId) {
    setError(null); setInfo(null);
    try {
      await supervisorApi.setUserSupervisor(id, { supervisorId, secondarySupervisorId, reason: 'admin override' });
      setInfo('Supervisor updated');
      refresh();
    } catch (err) { setError(err.response?.data?.message || 'Failed'); }
  }

  async function toggleTag(tagId) {
    const current = new Set(data.tags.map((t) => t.tag_id));
    if (current.has(tagId)) current.delete(tagId); else current.add(tagId);
    try {
      await supervisorApi.setUserTags(id, [...current]);
      refresh();
    } catch (err) { setError(err.response?.data?.message || 'Failed'); }
  }

  return (
    <section>
      <header className="page-header">
        <div>
          <p className="muted small"><Link to="/admin/users">Users</Link> ›</p>
          <h1>{data.user.name}</h1>
          <p className="muted">{data.user.email}</p>
        </div>
        <button className="btn ghost" onClick={() => nav(-1)}>Back</button>
      </header>

      {error && <div className="alert error">{error}</div>}
      {info && <div className="alert info">{info}</div>}

      <div className="grid-2">
        <div className="card">
          <h3>Supervisor</h3>
          <div className="kv">
            <div><strong>Resolved supervisor</strong></div>
            <div>{data.supervisor ? <UserPill user={data.supervisor} /> : <span className="muted">none</span>}</div>
            <div><strong>Secondary supervisor</strong></div>
            <div>{data.secondary ? <UserPill user={data.secondary} /> : <span className="muted">none</span>}</div>
          </div>
          <div className="grid-form" style={{ marginTop: 14 }}>
            <label>Override supervisor
              <select value={data.supervisor?.id || ''} onChange={(e) => setSupervisor(e.target.value || null, data.secondary?.id || null)}>
                <option value="">— none —</option>
                {users.filter((u) => u.id !== id).map((u) => <option key={u.id} value={u.id}>{u.name} · {u.email}</option>)}
              </select>
            </label>
            <label>Secondary
              <select value={data.secondary?.id || ''} onChange={(e) => setSupervisor(data.supervisor?.id || null, e.target.value || null)}>
                <option value="">— none —</option>
                {users.filter((u) => u.id !== id).map((u) => <option key={u.id} value={u.id}>{u.name} · {u.email}</option>)}
              </select>
            </label>
          </div>

          <h4>Change log</h4>
          {data.log.length === 0 ? <div className="muted small">No changes recorded.</div> : (
            <table className="data-table">
              <thead><tr><th>When</th><th>From</th><th>To</th><th>By</th><th>Reason</th></tr></thead>
              <tbody>
                {data.log.map((l) => (
                  <tr key={l.id}>
                    <td className="muted small">{new Date(l.changed_at).toLocaleString()}</td>
                    <td>{l.old_name || '—'}</td>
                    <td>{l.new_name || '—'}</td>
                    <td className="muted">{l.changed_by_name}</td>
                    <td className="muted small">{l.reason || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="card">
          <h3>Tags</h3>
          <div className="vendor-grid">
            {allTags.map((t) => {
              const isOn = data.tags.some((x) => x.tag_id === t.id);
              return (
                <label key={t.id} className={`vendor-pick ${isOn ? 'picked' : ''}`} onClick={(e) => { e.preventDefault(); toggleTag(t.id); }}>
                  <span className="tag-swatch" style={{ background: t.color }} />
                  <span><strong>{t.name}</strong> <span className="muted small">{t.scope}</span></span>
                </label>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
